export { default } from "./InputPrice"
